module.exports = __webpack_public_path__ + "static/media/12.0450c3ef.jpg";